import { render } from "./ProviderCardList.vue?vue&type=template&id=4785a37b&scoped=true&ts=true"
import script from "./ProviderCardList.vue?vue&type=script&lang=ts"
export * from "./ProviderCardList.vue?vue&type=script&lang=ts"

import "./ProviderCardList.vue?vue&type=style&index=0&id=4785a37b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4785a37b"]])

export default __exports__